<div id="home-page" fxLayout="column" fxLayoutAlign="center center">
    <app-switcher [size]="'m-size'"></app-switcher>
</div>